(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/assets/javascripts/views/play-system-page.js') >= 0) return;  svs.modules.push('/modules/lotto/assets/javascripts/views/play-system-page.js');

'use strict';

const {
  productMapping
} = svs.numbergames;
const {
  LOTTO_WEDNESDAY,
  LOTTO_SATURDAY
} = productMapping.CONSTANTS;
svs.lotto.views.PlaySystemPage = Marionette.View.extend({
  viewOptions: ['showDrawCount', 'showPlayTogether'],
  showDrawCount: true,
  showPlayTogether: true,
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent,
    module: 'lotto',
    component: 'play'
  }],
  regions: {
    rowsContainerRegion: '#ngRowsContainerRegion',
    betslipRegion: '#ngBetslipRegion',
    payfooterRegion: '#ngPayfooterRegion'
  },
  template(data) {
    return svs.lotto.templates.play_page(data);
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
  },
  onRender() {
    if (svs.lotto.components.play) {
      const model = this.model || new svs.numbergames.game_model.models.Wager({
        productId: productMapping.CONSTANTS.LOTTO,
        selectedDays: [LOTTO_WEDNESDAY, LOTTO_SATURDAY],
        boards: 1,
        rowPriceMulti: 2,
        jokerPrice: 10,
        jokerRow: svs.numbergames.rules.joker.getHuxfluxedRow(),
        isSystem: true
      }, {
        storageKey: 'system',
        parse: true,
        hasTickets: svs.lotto.data.hasTickets
      });
      this.showChildView('rowsContainerRegion', new svs.lotto.components.play.views.SystemRowContainer({
        model
      }));
      this.showChildView('betslipRegion', new svs.lotto.components.play.views.Betslip({
        model,
        showDrawCount: this.showDrawCount,
        showPlayTogether: this.showPlayTogether
      }));
      this.showChildView('payfooterRegion', new svs.lotto.components.play.views.Payfooter({
        model
      }));
    }
  }
});

 })(window);